var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popularize-duba-huyan-wrap"},[_c('video',{attrs:{"src":"//wallpaperm-mp4.duba.com/live/video/828a818e884bd72b3d5c86da6d1c1e4c.mp4","loop":"","muted":"","autoplay":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }